module.exports = {
  index: '/datetime-ui',
  reschedule: '/reschedule-bookings',
  availability: '/availability',
};
